module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes],
    staticStyle: {
      "background-color": "#fecd2f"
    }
  }, [_c('user-dash-header', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "margin-left": "0px!important",
      "background-color": "#ffffff"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('router-view')], 1)]), _vm._v(" "), _c('user-dash-footer', {
    staticStyle: {
      "margin-left": "0px!important"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13fe9999"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/user/layout/UserDashView.vue
// module id = 2066
// module chunks = 1